import { useSearchPageMapData } from "@/providers/search";
import { useMap } from "@vis.gl/react-google-maps";
import { Loader2 as LoaderCircleIcon } from "lucide-react";
import React from "react";
import { ProjectMarker } from "./project-marker";

export const ProjectMarkers = React.memo(function ProjectMarkers() {
	const map = useMap();
	const markers = useSearchPageMapData(state => state.nearByprojects);
	const [currentZoom, setCurrentZoom] = React.useState<number>(() => map?.getZoom() ?? 14);

	// Listen to zoom changes
	React.useEffect(() => {
		if (!map) return;

		const zoomListener = map.addListener("zoom_changed", () => {
			const zoom = map.getZoom();
			if (zoom !== undefined) {
				setCurrentZoom(zoom);
			}
		});

		return () => {
			if (zoomListener) {
				zoomListener.remove();
			}
		};
	}, [map]);

	if (!map) {
		return (
			<div className="absolute inset-0 flex items-center justify-center bg-white/50 z-10">
				<LoaderCircleIcon className="w-8 h-8 animate-spin text-primary-500" />
				<span className="ml-2 text-gray-600">Initializing map...</span>
			</div>
		);
	}

	return (
		<>
			{markers.map((marker, index) => (
				<ProjectMarker
					key={`marker-${marker._id?.toString()}-${marker.projectId || index}`}
					marker={marker}
					index={index}
					currentZoom={currentZoom}
				/>
			))}
		</>
	);
});
